import {
    ORDERS_REQUEST,
    ORDERS_SUCCESS,
    ORDERS_FAIL,
    UPDATE_ORDER,
    CREATE_ORDER,
    DELETE_ORDER,
    SHOW_ORDER_POPUP,
    DUPLICATE_ORDER_POPUP,
    HIDE_ORDER_POPUP,
    SHOW_EXPIRED_ORDERS_POPUP,
    SHOW_COMPLETED_TRADES_POPUP,
    HIDE_EXPIRED_ORDERS_POPUP,
    HIDE_COMPLETED_TRADES_POPUP,
    SET_ORDER_POPUP_MODE,
    BEHALF_USERS_REQUEST,
    BEHALF_USERS_SUCCESS,
    BEHALF_USERS_FAIL,
    BEHALF_USERS_EXTRA_REQUEST,
    BEHALF_USERS_EXTRA_SUCCESS,
    BEHALF_USERS_EXTRA_FAIL,
    SHOW_POPUP,
    SHOW_PROGRESS,
    HIDE_PROGRESS,
    HIDE_CONTEXT,
    SET_SHOW_TRADED,
    USERS_WITH_NOTIFICATIONS_SUCCESS,
    USERS_WITH_NOTIFICATIONS_FAIL,
} from '../constants/action-types';

import { errorMessages } from '../constants/errorMessages';

import {
    getOrdersRequest,
    getOrderRequest,
    getOnBehalfOfUsers,
    updateAndSubmitOrder,
    deleteOrderRequest,
    setShowTradedRequest,
    getUsersWithNotificationRequest,
    deleteWorkingOrdersRequest
} from '../services/api';

export function getOrders(type) {
    return (dispatch) => {
        getOrdersRefresh(type, dispatch);
    }
}

export function getOrder(id, mode, callback, intent = null) {
    return (dispatch) => {
        dispatch({type: SHOW_PROGRESS});
        return getOrderRequest(id).then( result => {
            dispatch({type: HIDE_PROGRESS});
            if (typeof callback == 'function') { 
                if(intent) {
                    result.data["intent"] = intent
                }
                callback(mode, result.data);
            }
        }).catch( error => {
            dispatch({type: HIDE_PROGRESS});
            console.log(error);
        });
    }
}

export function getBehalfUsers(params, cb) {
    return (dispatch) => {
        getBehalfUsersRefresh(dispatch, false, params, cb)
    }
}

export function getBehalfUsersExtra(params, cb) {
    return (dispatch) => {
        getBehalfUsersRefresh(dispatch, true, params, cb)
    }
}

export function getUsersWithNotification(params, callback) {
    return (dispatch) => {
        return getUsersWithNotificationRequest(params).then(result => {
            dispatch({ type: USERS_WITH_NOTIFICATIONS_SUCCESS, users: result.data });
            if (typeof callback == 'function') callback(result.data);
        }).catch(error => {
            dispatch({ type: USERS_WITH_NOTIFICATIONS_FAIL, error: error });
        });
    }
}

const getOrdersRefresh = (type, dispatch) => {
    dispatch({ type: ORDERS_REQUEST });
    return getOrdersRequest(type).then( result => {
        dispatch({
            type: ORDERS_SUCCESS,
            payload: result.data,
            orderType: type
        });
    }).catch( error => {
        dispatch({
            type: ORDERS_FAIL,
            error: error
        });
    });
}

const getBehalfUsersRefresh = (dispatch, isExtra, params, cb) => {
    dispatch({type: isExtra ? BEHALF_USERS_EXTRA_REQUEST : BEHALF_USERS_REQUEST});
    return getOnBehalfOfUsers(params).then( result => {
        dispatch({
            type: isExtra ? BEHALF_USERS_EXTRA_SUCCESS : BEHALF_USERS_SUCCESS,
            payload: result.data,
        });
        if (typeof cb == 'function') cb();
    }).catch( error => {
        dispatch({
            type: isExtra ? BEHALF_USERS_EXTRA_FAIL : BEHALF_USERS_FAIL,
            payload: [],
            error: error
        });
    });
}

export function manageOrder(mode, args, successTitle, popupText, callback, popupTextAfter) {
    const isUpdate = mode.indexOf('edit') >= 0;
    let title = `You are about to ${isUpdate?'update':'enter'} the following ${mode=='create-finalised'?'finalised contract':'order'}`;
    let successText = popupTextAfter ? popupTextAfter : `${isUpdate? '' : 'Order summary:\n\n'} ${popupText}`;
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title,
                content: popupText+'\n\nPlease confirm',
                isConfirm: true,
                buttonAction: () => {
                    dispatch({type: SHOW_PROGRESS});
                    dispatch({type: isUpdate? UPDATE_ORDER : CREATE_ORDER});
                    updateAndSubmitOrder(mode, args).then( result => {
                        dispatch({type: HIDE_PROGRESS});
                        dispatch({type: HIDE_ORDER_POPUP});
                        callback();
                        dispatch({
                            type: SHOW_POPUP,
                            popupProps: {
                                title: successTitle,
                                content: successText
                            }
                        });

                    }).catch( error => {
                        const { status, data } = error.response;
                        dispatch({type: HIDE_PROGRESS});
                        dispatch({type: HIDE_ORDER_POPUP});

                        if (status == 419 || status == 420) {
                            dispatch({
                                type: SHOW_POPUP,
                                popupProps: {
                                    title: 'Error',
                                    content: errorMessages[status.toString()],
                                }
                            });
                        }
                        if (status == 400) {
                            dispatch({
                                type: SHOW_POPUP,
                                popupProps: {
                                    title: 'Error',
                                    content: JSON.stringify(data),
                                }
                            });
                        }
                    });
                }
            }
        });
    }
}

export function deleteOrder(id, popupText) {
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'You are about to delete following order.',
                content: popupText+'\n\nDo you really want to do this?',
                isConfirm: true,
                buttonAction: () => {
                    dispatch({type: SHOW_PROGRESS});
                    dispatch({type: DELETE_ORDER});
                    deleteOrderRequest(id).then( result => {
                        dispatch({type: HIDE_PROGRESS});
                        dispatch({type: HIDE_ORDER_POPUP});
                        dispatch({
                            type: SHOW_POPUP,
                            popupProps: {
                                title: 'Order was deleted',
                                content: popupText,
                            }
                        });
                    }).catch( error => {
                        dispatch({type: HIDE_PROGRESS});
                        dispatch({type: HIDE_ORDER_POPUP});
                        dispatch({type: HIDE_CONTEXT});
                    });
                }
            }
        });
    }
}

export function showOrderPopup(mode, formData) {
  return {
    type: SHOW_ORDER_POPUP,
    popupMode: mode,
    formData: formData
  }
}
export function showExpiredOrdersPopup(/*mode, formData*/) {
  return {
    type: SHOW_EXPIRED_ORDERS_POPUP,
    //popupMode: mode, // NOTE: Not sure if this is right / necessary
    //formData: formData // NOTE: Not sure if this is right / necessary
  }
}
export function showCompletedTradesPopup(/*mode, formData*/) {
  return {
    type: SHOW_COMPLETED_TRADES_POPUP,
    //popupMode: mode, // NOTE: Not sure if this is right / necessary
    //formData: formData // NOTE: Not sure if this is right / necessary
  }
}

export function duplicateOrderPopup(mode, formData) {
    return {
        type: DUPLICATE_ORDER_POPUP,
        popupMode: mode,
        formData: formData
      }
}

export function hideOrderPopup() {
  return {
    type: HIDE_ORDER_POPUP,
  }
}
export function hideExpiredOrdersPopup() {
  return {
    type: HIDE_EXPIRED_ORDERS_POPUP,
  }
}
export function hideCompletedTradesPopup() {
  return {
    type: HIDE_COMPLETED_TRADES_POPUP,
  }
}

export function setOrderPopupMode(mode) {
  return {
    type: SET_ORDER_POPUP_MODE,
    mode
  }
}

export function setShowTraded(id, value, cb) {
    return (dispatch) => {
        dispatch({type: SET_SHOW_TRADED});
        dispatch({type: SHOW_PROGRESS});
        return setShowTradedRequest(id, value).then( result => {
            dispatch({type: HIDE_PROGRESS});
            if (typeof cb == 'function') cb();
        }).catch( error => {
            dispatch({type: HIDE_PROGRESS});
            console.log(error);
        });
    }
}

export function deleteWorkingOrders() {
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Delete all working orders',
                content: 'You are about to delete all your working orders. Do you really want to do this?',
                isConfirm: true,
                buttonAction: () => {
                    dispatch({type: SHOW_PROGRESS});
                    deleteWorkingOrdersRequest().then( result => {
                        dispatch({type: HIDE_PROGRESS});
                        getOrdersRefresh('workingOrders', dispatch);
                        dispatch({
                            type: SHOW_POPUP,
                            popupProps: {
                                title: 'Success',
                                content: 'Working orders were deleted',
                            }
                        });
                    }).catch( error => {
                        dispatch({type: HIDE_PROGRESS});
                    });
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./source/actions/ordersActions.js